import { Link } from "react-router-dom";
import { useAuthentication } from "@myinnsworth/hooks/authenticationHook";
import { useAppStore } from "@myinnsworth/hooks/appStoreHook";
import { useResponsiveHelper } from "@myinnsworth/hooks/responsiveHelperHook";
import { authenticationHttpService } from "@myinnsworth/httpServices";

export interface IMenuProps {
    onNavigateAway: () => void;
}

export default function Menu(props: IMenuProps) {
    const appStore = useAppStore();
    const auth = useAuthentication();
    const {isResponsive} = useResponsiveHelper();
    
    const signOut = async () => {
        try {
            await authenticationHttpService.signOut();
        } catch {

        } finally {
            props.onNavigateAway();
        }

    };

    return (
        <menu>
            <p>Cases</p>
            <ul>
                {/* {appStore.cases.map(x => <li key={x.slug}> <Link onClick={() => props.onNavigateAway()} to={`/cases/${x.slug}/${(auth.userCases?.some(c => c.slug === x.slug) ? 'investor-updates' : 'news')}`} >{x.name}</Link> </li>)} */}
                {appStore.cases.map(x => <li key={x.slug}> <Link onClick={() => props.onNavigateAway()} to={`/cases/${x.slug}/news`} >{x.name}</Link> </li>)}
            </ul>
            {isResponsive && (<>
                <p>Account</p>
                <ul>
                    <li><Link to={"/settings/profile"} onClick={() => props.onNavigateAway()}>Profile settings</Link></li>
                    <li><Link to={"/settings/account"} onClick={() => props.onNavigateAway()}>Account settings</Link></li> 
                    <li><Link to={"/auth/sign-in"} onClick={() => signOut()}>Log out</Link></li> 
                </ul>
                </>)}
        </menu>
    )
}